import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import paymentService from './paymentService';
import toast from 'react-hot-toast'; // Optional for notifications

const initialState = {
    clientSecret: null,
    isLoading: false,
    isSuccess: false,
    isError: false,
    message: '',
};

// **Async Thunks**

// Create Payment Intent
export const createPaymentIntent = createAsyncThunk(
    'payment/createPaymentIntent',
    async ({ amount, token }, thunkAPI) => {
        try {
            return await paymentService.createPaymentIntent(amount, token);
        } catch (error) {
            const message = error.response?.data?.message || error.message || 'Failed to create payment intent';
            toast.error(message); // Optional toast for errors
            return thunkAPI.rejectWithValue(message);
        }
    }
);

// **Payment Slice**
const paymentSlice = createSlice({
    name: 'payment',
    initialState,
    reducers: {
        resetPayment: (state) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.isError = false;
            state.message = '';
            state.clientSecret = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // Create Payment Intent
            .addCase(createPaymentIntent.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createPaymentIntent.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.clientSecret = action.payload.clientSecret; // Set the client secret
            })
            .addCase(createPaymentIntent.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            });
    },
});

// Export actions and reducer
export const { resetPayment } = paymentSlice.actions;
export default paymentSlice.reducer;
